import React, { useState, useEffect } from 'react';
import { compose } from 'ramda';
import queryString from 'query-string';
import styled from 'styled-components/macro';
import { Link as RouterLink } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { Typography, showToast } from '@deeptrue-frontend/ui';
import signInSplash from 'assets/images/sign-in.png';
import Forms from 'components/Forms';
import { useFormatMessage } from 'components/IntlProvider';
import QUERIES from 'consts/queries';
import { withMetaDescription } from 'components/HeadProvider/HeadProvider';
import { SidePage } from 'components/Layout';
import api from 'api/api';
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-right.svg';

const StyledArrowIcon = styled(ArrowIcon)`
  width: 16px;
  margin-right: 8px;
  transform: rotate(180deg);
`;

const BackContainer = styled.div`
  width: 100%;
  margin-top: 1.5rem;
  margin-bottom: 3rem;
  a {
    display: flex;
    color: ${({ theme }) => theme.colors.royalBlue};
    font-weight: 600;
  }
`;

const RemindPassword = ({ history: { location } }: any) => {
  const [emailIsSend, setEmailIsSend] = useState(false);
  const t = useFormatMessage();
  const { action } = queryString.parse(location.search);

  useEffect(() => {
    if (action === QUERIES.RESET_TOKEN_INVALID) {
      showToast({
        type: 'info',
        title: t(
          'pages.remindpassword.invalidToken',
          'Reset code already used or invalid'
        ),
        id: 'reset token invalid',
      });
    }
    // eslint-disable-next-line
  }, []);

  const onSubmit = (values: { email: string }) => {
    return api.resources
      .forgotPasswordSendEmail(values)
      .then(() => {
        setEmailIsSend(true);
      })
      .catch((err) => {
        Forms.helpers.throwError(err.response.data);
      });
  };

  return (
    <SidePage
      title="Forgot Password"
      splashImage={signInSplash}
      slogan={
        <Typography color="white" variant="h4" mt="8rem">
          {t(
            'pages.auth.header',
            "On deeptrue's workbenches you will find well-founded, ready-to-go insight tools"
          )}
        </Typography>
      }
    >
      {emailIsSend && (
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="copy1" mt="1.5rem" mb="1.5rem">
              {t(
                'pages.remindpassword.success',
                '"We will send you and email with reset link if email you provided is correct.'
              )}
            </Typography>
          </Grid>
        </Grid>
      )}
      <BackContainer>
        <Typography variant="copy1" color="royalBlue">
          <RouterLink to="/">
            <StyledArrowIcon />
            {t('pages.forgot.goback', 'Back to sign in page')}
          </RouterLink>
        </Typography>
      </BackContainer>
      {!emailIsSend && (
        <Forms.ForgotPassword
          onSubmit={onSubmit}
          initialValues={{ email: '' }}
        />
      )}
    </SidePage>
  );
};

export default compose(withMetaDescription({ title: 'Forgot Password' }))(
  RemindPassword
);
